export default "__VITE_ASSET__BxCk9_$d__"